import Axios from "axios";
import config from "../config";

class ExchangeService {
  getCurrentPrice(coin) {
    return Axios.get(config.api.exchange + "/price/" + coin)
      .then((response) => {
        return response.data; // Directly return the price number
      })
      .catch(error => {
        console.error("Price fetch error:", error);
        throw error;
      });
  }

  getPercentChange(coin) {
    return Axios.get(config.api.exchange + "/information/" + coin)
      .then((response) => {
        return {
          hour: response.data.percent_change_1h || 0,
          day: response.data.percent_change_24h || 0,
          week: response.data.percent_change_7d || 0
        };
      })
      .catch(error => {
        console.error("Percent change fetch error:", error);
        return { hour: 0, day: 0, week: 0 };
      });
  }
}

export default new ExchangeService();